module.exports = __webpack_public_path__ + "static/media/CancelPolicyDisabled.f3364293.svg";